import { FIELD_TYPES } from "constants/template-field-type";
import defaultProps from "./amanda-meeting-wizard-default-props";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Amanda Meeting Wizard",
    fields: {
        amandaAgentConfig: {
            type: FIELD_TYPES.TEXT,
            label: "Amanda agent config (stringified JSON)",
            defaultValue: defaultProps.amandaAgentConfig
        },
        qualifiedRedirectDelayMs: {
            type: FIELD_TYPES.TEXT,
            label: "Qualified redirect delay (ms)",
            defaultValue: defaultProps.qualifiedRedirectDelayMs
        },
        unqualifiedRedirectDelayMs: {
            type: FIELD_TYPES.TEXT,
            label: "Unqualified redirect delay (ms)",
            defaultValue: defaultProps.unqualifiedRedirectDelayMs
        },
        unqualifiedRedirectUrl: {
            type: FIELD_TYPES.TEXT,
            label: "Unqualified redirect URL (overrides thank-you step if set)"
        },
        agentChatStepTextLabels: {
            type: FIELD_TYPES.NESTED,
            label: "Agent Chat Step",
            fields: {
                eyebrow: {
                    type: FIELD_TYPES.TEXT,
                    label: "Eyebrow",
                    translatable: true
                },
                title: {
                    type: FIELD_TYPES.TEXT,
                    label: "Title",
                    translatable: true
                },
                stepYourInfoLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 1 — Your info label",
                    translatable: true
                },
                stepTellUsMoreLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 2 — Tell us more label",
                    translatable: true
                },
                stepMeetWithUsLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 3 — Meet with us label",
                    translatable: true
                },
                firstMessage: {
                    type: FIELD_TYPES.TEXT,
                    label: "Agent first message (supports {{first_name}}, {{main_product}})",
                    translatable: true
                }
            }
        },
        meetWithUsStepTextLabels: {
            type: FIELD_TYPES.NESTED,
            label: "Meet With Us Step",
            fields: {
                title: {
                    type: FIELD_TYPES.TEXT,
                    label: "Title",
                    translatable: true
                },
                stepFormLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 1 — Form label",
                    translatable: true
                },
                stepTellUsMoreLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 2 — Tell us more label",
                    translatable: true
                },
                stepMeetWithUsLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 3 — Meet with us label",
                    translatable: true
                }
            }
        },
        thankYouStepTextLabels: {
            type: FIELD_TYPES.NESTED,
            label: "Thank You Step",
            fields: {
                eyebrow: {
                    type: FIELD_TYPES.TEXT,
                    label: "Eyebrow",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.eyebrow
                },
                title: {
                    type: FIELD_TYPES.TEXT,
                    label: "Title",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.title
                },
                stepYourInfoLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 1 — Your info label",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.stepYourInfoLabel
                },
                stepTellUsMoreLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 2 — Tell us more label",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.stepTellUsMoreLabel
                },
                stepDoneLabel: {
                    type: FIELD_TYPES.TEXT,
                    label: "Step 3 — Done label",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.stepDoneLabel
                },
                thankYouBadgeImage: {
                    type: FIELD_TYPES.NESTED,
                    label: "Done badge image",
                    fields: {
                        src: {
                            type: FIELD_TYPES.GALLERY,
                            label: "Image",
                            defaultValue: defaultProps.thankYouStepTextLabels.thankYouBadgeImage.src
                        },
                        alt: {
                            type: FIELD_TYPES.TEXT,
                            label: "Alt text",
                            translatable: true,
                            defaultValue: defaultProps.thankYouStepTextLabels.thankYouBadgeImage.alt
                        }
                    }
                },
                thankYouTitle: {
                    type: FIELD_TYPES.TEXT,
                    label: "Thanks title",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.thankYouTitle
                },
                thankYouSubtitle: {
                    type: FIELD_TYPES.TEXT,
                    label: "Thanks subtitle",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.thankYouSubtitle
                },
                helpCenterPrefix: {
                    type: FIELD_TYPES.TEXT,
                    label: "Help Center prefix",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.helpCenterPrefix
                },
                helpCenterLinkText: {
                    type: FIELD_TYPES.TEXT,
                    label: "Help Center link text",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.helpCenterLinkText
                },
                helpCenterLinkUrl: {
                    type: FIELD_TYPES.TEXT,
                    label: "Help Center link URL",
                    defaultValue: defaultProps.thankYouStepTextLabels.helpCenterLinkUrl
                },
                helpCenterSuffix: {
                    type: FIELD_TYPES.TEXT,
                    label: "Help Center suffix",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.helpCenterSuffix
                },
                recordingDisclaimer: {
                    type: FIELD_TYPES.TEXT,
                    label: "Recording disclaimer",
                    translatable: true,
                    defaultValue: defaultProps.thankYouStepTextLabels.recordingDisclaimer
                }
            }
        }
    }
};
